import { useEffect } from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import MuiButton from '@mui/material/Button'
import { Link as RouterLink } from 'react-router-dom'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import Container from '../components/common/Container'

export default function NotFound() {
  useEffect(() => {
    document.title = 'Page Not Found — Future of Farm Food Library'
  }, [])

  return (
    <Box sx={{ py: { xs: 10, md: 16 }, textAlign: 'center' }}>
      <Container narrow>
        <Typography
          variant="h1"
          sx={{
            fontSize: { xs: '4rem', md: '6rem' },
            fontWeight: 700,
            color: 'primary.main',
            opacity: 0.25,
            mb: 2,
            lineHeight: 1,
          }}
        >
          404
        </Typography>
        <Typography variant="h3" sx={{ mb: 2, fontSize: { xs: '1.5rem', md: '2rem' } }}>
          Page not found
        </Typography>
        <Typography variant="body1" sx={{ color: 'text.secondary', mb: 4 }}>
          The page you are looking for does not exist. It may have been moved or the URL may be incorrect.
        </Typography>
        <MuiButton
          component={RouterLink}
          to="/"
          variant="contained"
          color="primary"
          size="large"
          startIcon={<ArrowBackIcon />}
        >
          Back to Home
        </MuiButton>
      </Container>
    </Box>
  )
}
